// Design tokens AMC Ticket — palette violet AGNOS

export const tokens = {
  bg:           '#F7F5FA',
  surface:      '#FFFFFF',
  surfaceAlt:   '#F0EBF7',
  ink:          '#1F1830',
  inkSoft:      '#555555',
  inkMuted:     '#9C95A8',
  border:       '#E8E2F0',
  borderStrong: '#D5CCE2',
  accent:       '#6B3FA0',
  accentSoft:   '#8B5FBF',
  accentBg:     '#F0EBF7',
  warning:      '#B45309',
  warningBg:    '#FEF3C7',
  danger:       '#B91C1C',
  dangerBg:     '#FEE2E2',
  success:      '#15803D',
  successBg:    '#DCFCE7',
  info:         '#1E40AF',
  infoBg:       '#DBEAFE',
};

export const fontStack = `'Geist', -apple-system, BlinkMacSystemFont, sans-serif`;

// Cycle de vie : statuts actifs (en cours de traitement) vs clos (finis).
export const STATUTS_ACTIFS = [
  'clarification_ia', 'nouveau', 'clarification_admin',
  'pris_en_compte', 'en_cours',
];
export const STATUTS_CLOS = ['resolu', 'refuse', 'doublon'];

// Type de ticket
export const couleursType = {
  bug: {
    bg: tokens.dangerBg, fg: tokens.danger,
    label: '🐛 Bug', titre: 'Bug / dysfonctionnement',
    hint: 'Quelque chose ne fonctionne pas comme prévu',
  },
  evolution: {
    bg: tokens.infoBg, fg: tokens.info,
    label: '💡 Évolution', titre: 'Demande d\'évolution',
    hint: 'Une fonctionnalité à améliorer ou à ajouter pour répondre à un besoin métier',
  },
};

// Libellés des 3 champs de description selon le type
export const champsDescription = {
  bug: {
    action:      { label: 'Que faisais-tu ?',                placeholder: "Ex : Je voulais valider une facture client sur la page Factures > Liste" },
    observation: { label: 'Que s\'est-il passé ?',           placeholder: "Ex : Le bouton Valider devient gris puis je vois 'Erreur 500' en rouge" },
    attendu:     { label: 'À quoi tu t\'attendais ?',        placeholder: "Ex : Le statut de la facture devait passer à 'Validée'" },
  },
  evolution: {
    action:      { label: 'Quel besoin métier ?',            placeholder: "Ex : Pouvoir exporter en CSV la liste des commandes filtrée" },
    observation: { label: 'Comment tu fais aujourd\'hui ?',  placeholder: "Ex : Je copie-colle ligne par ligne dans Excel, ~30 min par lot de 50" },
    attendu:     { label: 'Quelle solution proposes-tu ?',   placeholder: "Ex : Un bouton 'Exporter CSV' qui respecte les filtres en cours" },
  },
};

export const couleursStatut = {
  clarification_ia:    { bg: tokens.warningBg, fg: tokens.warning, label: 'Clarification IA' },
  nouveau:             { bg: tokens.infoBg,    fg: tokens.info,    label: 'Nouveau' },
  clarification_admin: { bg: tokens.warningBg, fg: tokens.warning, label: 'Clarification admin' },
  pris_en_compte:      { bg: tokens.accentBg,  fg: tokens.accent,  label: 'Pris en compte' },
  en_cours:            { bg: tokens.accentBg,  fg: tokens.accent,  label: 'En cours' },
  resolu:              { bg: tokens.successBg, fg: tokens.success, label: 'Résolu' },
  refuse:              { bg: tokens.dangerBg,  fg: tokens.danger,  label: 'Refusé' },
  doublon:             { bg: tokens.surfaceAlt, fg: tokens.inkSoft, label: 'Doublon' },
};

export const couleursGravite = {
  bloquant:    { bg: tokens.dangerBg,  fg: tokens.danger,  label: 'Bloquant' },
  majeur:      { bg: tokens.warningBg, fg: tokens.warning, label: 'Majeur' },
  mineur:      { bg: tokens.infoBg,    fg: tokens.info,    label: 'Mineur' },
  cosmetique:  { bg: tokens.surfaceAlt, fg: tokens.inkSoft, label: 'Cosmétique' },
};

export const couleursImpact = {
  bloquant:      { bg: tokens.dangerBg,  fg: tokens.danger,  label: '🔴 Bloquant',      hint: 'Je ne peux pas faire mon travail' },
  contournement: { bg: tokens.warningBg, fg: tokens.warning, label: '🟠 Contournement', hint: 'C\'est cassé mais je m\'en sors' },
  agacant:       { bg: tokens.infoBg,    fg: tokens.info,    label: '🟡 Agaçant',       hint: 'Ça marche mais c\'est pénible' },
  cosmetique:    { bg: tokens.surfaceAlt, fg: tokens.inkSoft, label: '⚪ Cosmétique',    hint: 'Détail visuel' },
};

export const couleursUrgence = {
  urgent:        { bg: tokens.dangerBg,  fg: tokens.danger,  label: 'Urgent' },
  peut_attendre: { bg: tokens.surfaceAlt, fg: tokens.inkSoft, label: 'Peut attendre' },
};
